import React, { useContext, useEffect } from 'react';

import { TEACHER_ASSIGNMENT_V2_INSIGHTS_URL } from 'config/urls';

import { trackMixpanelPageView } from 'utils/integrations/mixpanel';

import TrackerInstanceSectionContext from 'components/TrackerInstanceSectionContext';
import Typography from 'components/Typography';
import UserContext from 'components/UserContext';

import { ReactComponent as LoaderImage } from './assets/loader.svg';
import styles from './styles.module.scss';

const LoadingState = () => {
  const user = useContext(UserContext);
  const { class_id, standards } = useContext(TrackerInstanceSectionContext);

  useEffect(() => {
    trackMixpanelPageView(user.id, {
      feature: 'insights',
      view: 'loading-state',
      class_id,
      standards,
      normalizedURL:
        process.env.REACT_APP_BASE_FRONTEND_URL +
        TEACHER_ASSIGNMENT_V2_INSIGHTS_URL
    });
  }, [user, class_id, standards]);

  return (
    <div className={`${styles.loaderContainer} ${styles.bounceAnimation}`}>
      <div className={styles.imageContainer}>
        <LoaderImage />
        <div
          className={`${styles.dotsContainer} ${styles.loading} ${styles.bounceAnimation}`}
        >
          <div className={`${styles.dot} forward-animation`}></div>
          <div className={`${styles.dot} forward-animation`}></div>
          <div className={`${styles.dot} forward-animation`}></div>
        </div>
      </div>
      <Typography variant="H-TEXT-1" className={styles.text}>
        Getting Your Insights ...
      </Typography>
    </div>
  );
};

export default LoadingState;
